/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    dropdown: {
      description: 'activate the dropdown menu',
      type: 'variant',
      values: [ true ]
    },
    equalWidth: {
      description: 'Divide the available width equally among `TabsItem`',
      type: 'variant',
      values: [ true ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { selected: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderRadius: 99,
        color: '#000000',
        highlightBarBorderWidth: 1,
        highlightBarHeight: 1,
        highlightColor: '#000000'
      }
    },
    {
      if: { hover: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderRadius: 99,
        highlightBarBorderWidth: 0,
        highlightBarHeight: 1,
        highlightColor: '#c9c8c8'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderRadius: 99,
        highlightBarBorderWidth: 0
      }
    },
    {
      if: { focus: true, selected: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderColor: '#000000',
        borderRadius: 99,
        borderWidth: 2,
        color: '#000000',
        highlightBarBorderWidth: 1,
        highlightBarHeight: 1,
        highlightColor: '#000000'
      }
    },
    {
      if: { hover: true, selected: true },
      tokens: {
        highlightBarBorderWidth: 1,
        highlightBarHeight: 1,
        highlightColor: '#000000'
      }
    },
    {
      if: { focus: true },
      tokens: {
        borderColor: '#000000',
        borderRadius: 99,
        borderWidth: 2,
        color: '#000000'
      }
    },
    {
      if: { inverse: true },
      tokens: { backgroundColor: 'transparent', color: '#ffffff' }
    },
    {
      if: { inverse: true, selected: true },
      tokens: {
        backgroundColor: '#ffffff',
        borderRadius: 99,
        color: '#000000',
        highlightBarBorderWidth: 1,
        highlightBarHeight: 1,
        highlightColor: '#ffffff'
      }
    },
    {
      if: { hover: true, inverse: true },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: 99,
        color: '#ffffff'
      }
    },
    {
      if: { focus: true, inverse: true, selected: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#ffffff',
        borderRadius: 99,
        borderWidth: 2,
        color: '#000000'
      }
    },
    {
      if: { focus: true, inverse: true },
      tokens: {
        borderColor: '#ffffff',
        borderRadius: 99,
        borderWidth: 2,
        color: '#ffffff'
      }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        borderRadius: 99,
        highlightBarBorderWidth: 0
      }
    },
    { if: { focus: true, inverse: true, selected: true }, tokens: {} },
    { if: { equalWidth: true }, tokens: { maxWidth: null } },
    {
      if: { dropdown: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 32,
        borderWidth: 1,
        color: '#000000'
      }
    },
    {
      if: { dropdown: true, hover: true, viewport: [ 'xs', 'sm' ] },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }
    },
    {
      if: { dropdown: true, focus: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#000000',
        borderWidth: 1,
        color: '#000000'
      }
    },
    {
      if: { dropdown: true, pressed: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#000000'
      }
    },
    {
      if: { dropdown: true, selected: true, viewport: [ 'xs', 'sm' ] },
      tokens: { backgroundColor: 'rgba(0, 0, 0, 0.1)', color: '#000000' }
    },
    {
      if: { dropdown: true, inverse: true, viewport: [ 'xs', 'sm' ] },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 1,
        color: '#ffffff'
      }
    },
    {
      if: {
        dropdown: true,
        hover: true,
        inverse: true,
        viewport: [ 'xs', 'sm' ]
      },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)', color: '#ffffff' }
    },
    {
      if: {
        dropdown: true,
        inverse: true,
        selected: true,
        viewport: [ 'xs', 'sm' ]
      },
      tokens: { backgroundColor: '#ffffff', color: '#000000' }
    },
    {
      if: {
        dropdown: true,
        focus: true,
        inverse: true,
        viewport: [ 'xs', 'sm' ]
      },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: '#ffffff',
        borderWidth: 1
      }
    },
    {
      if: {
        dropdown: true,
        inverse: true,
        pressed: true,
        viewport: [ 'xs', 'sm' ]
      },
      tokens: {
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#ffffff'
      }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderColor: 'transparent',
    borderRadius: 0,
    borderWidth: 0,
    color: '#000000',
    dropdownIcon: PaletteIconChevronDown,
    dropdownIconExpanded: PaletteIconChevronUp,
    fontName: 'StagSans',
    fontScaleCap: 64,
    fontSize: 16,
    fontWeight: '600',
    highlightBarBorderRadius: 0,
    highlightBarBorderWidth: 0,
    highlightBarHeight: 0,
    highlightColor: 'transparent',
    highlightTriangleSize: 0,
    letterSpacing: 0,
    lineHeight: 1.5,
    marginHorizontal: 4,
    marginVertical: 0,
    maxWidth: null,
    paddingHorizontal: 24,
    paddingVertical: 4,
    space: 1,
    textAlign: 'center',
    textTransform: 'none'
  }
}
export default theme
